import { render, staticRenderFns } from "./ChatMessageElement.vue?vue&type=template&id=967e09ae&scoped=true"
import script from "./ChatMessageElement.vue?vue&type=script&lang=js"
export * from "./ChatMessageElement.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageElement.vue?vue&type=style&index=0&id=967e09ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967e09ae",
  null
  
)

export default component.exports